import { NotAdminAuthorized } from "./NotAdminAuthorized";
import { NotSignedIn } from "./NotSignedIn";
import { AuthContextState } from "../AuthWrapper";

export function NotAuthorizedComponent({ state, loggedIn }: { state: AuthContextState, loggedIn: boolean }) {

  if (state.user && !state.user?.admin) {
    return <NotAdminAuthorized />;
  }
  
  if (!loggedIn) {
    return <NotSignedIn/>
  }
  return null;
}

